// extracted by mini-css-extract-plugin
export default {"storeContainer":"WatchMovies_storeContainer__11J2f","storeBox":"WatchMovies_storeBox__FVXty"};